import React from 'react';
import PropTypes from 'prop-types';

const Products = ({ data }) => (
  <ul>
    {data.map((e, i) => (
      <li key={i}>- {e.title}</li>
    ))}
  </ul>
);

Products.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ),
}

export default Products;